var MessageErrorAction = {
  UPDATE: "UPDATE",
  INSERT: "INSERT",
};


export default MessageErrorAction;

